import React, { useEffect, useMemo, useRef, useState } from "react"
import TableContainer from "components/Common/TableContainer"
import moment from "moment"
import {
  useDeleteRolesMutation,
  useLazyGetRolesQuery,
} from "store/api/roles/roles.api"

import { Link, useNavigate } from "react-router-dom"
import edit from "../../assets/images/icons/edit.svg"
import deleteIcon from "../../assets/images/icons/delete-red.svg"
import DeleteConfirmationModal from "modals/deleteConfirmation"
import { UncontrolledTooltip } from "reactstrap"
import { getTableSortingHeaderIcon } from "helpers/common"

const defaultFilters = {
  search: "",
  page: 1,
  pageSize: 20,
  timestamp: "",
}

const RolesTable = ({ HeaderComponent }) => {
  const [getResults, { isFetching }] = useLazyGetRolesQuery()
  const [filters, setFilters] = useState(defaultFilters)
  const [data, setData] = useState([])
  const [count, setCount] = useState(0)
  const [isToast, setIsToast] = useState(false)
  const [onDelete, { isLoading: isDeleting }] = useDeleteRolesMutation()
  const history = useNavigate()
  const deleteRef = useRef()
  //meta title
  document.title = "Roles | Prachay"

  useEffect(() => {
    getList()
  }, [filters])

  const getList = async () => {
    try {
      const { data } = await getResults(filters).unwrap()
      setData(data?.rows)
      setCount(data?.count)
    } catch (e) {}
  }

  const onDeleteSuccess = () => {
    setIsToast(false)
    deleteRef.current = null
    setFilters((prev) => ({ ...prev, page: 1, timestamp: moment().unix() }))
  }

  const columns = useMemo(
    () => [
      {
        header: ({ column }) => getTableSortingHeaderIcon(column, "Role"),
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Description",
        accessorKey: "description",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        id: "action",
        header: "Actions",
        cell: ({ row }) => {
          const editTooltip = `editTooltip-${row?.original.id}`
          const deleteTooltip = `deleteTooltip-${row?.original.id}`
          return (
            <div className="d-flex justify-content-center align-items-center gap-3">
              <div className="action-view role-action">
                <Link to={`/user-management/roles/edit/${row?.original.id}`}>
                  <span id={editTooltip}>
                    <img src={edit} alt="" /> Edit
                  </span>
                  <UncontrolledTooltip placement="top" target={editTooltip}>
                    Edit
                  </UncontrolledTooltip>
                </Link>
              </div>
              <div
                className="action-delete role-action"
                onClick={() => {
                  deleteRef.current = row?.original
                  setIsToast(true)
                }}
              >
                <span id={deleteTooltip}>
                  <img src={deleteIcon} alt="" /> Delete
                </span>
                <UncontrolledTooltip placement="top" target={deleteTooltip}>
                  Delete
                </UncontrolledTooltip>
              </div>
            </div>
          )
        },
      },
    ],
    []
  )

  return (
    <>
      <TableContainer
        isLoading={isFetching}
        count={count}
        filters={filters}
        setFilters={setFilters}
        columns={columns}
        data={data}
        isGlobalFilter={true}
        isCustomPageSize={true}
        HeaderComponent={HeaderComponent}
        isPagination={true}
        pagination="pagination"
        paginationWrapper="dataTables_paginate paging_simple_numbers"
        tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
      />

      {isToast && deleteRef && (
        <DeleteConfirmationModal
          open={isToast}
          id={deleteRef.current.id}
          setOpen={setIsToast}
          isLoading={isDeleting}
          onClose={() => {
            setIsToast(false)
            deleteRef.current = null
          }}
          title={"Delete Role"}
          description="Are you sure you want to delete this role?"
          onDelete={onDelete}
          onSuccess={onDeleteSuccess}
        />
      )}
    </>
  )
}

export default RolesTable
